<template>
  <div :style="css">
    <el-input
      class="input_0"
      readonly
      placeholder="选择工单类型"
      @click.native="onInputClick"
      v-model="ticketType.name">
        <template slot="append" class="append_0">
          <i class="icon_0"
            @click.stop="onDelIconClick"
            @mouseover="onMouseover"
            @mouseout="onMouseout"
            :class="iconClass"></i>
        </template>
      </el-input>

    <el-dialog
      top="0"
      :modal="false"
      class="dialog_0"
      @opened="onOpened"
      :visible.sync="dialogVisible"
      :before-close="onBeforeClose"
      width="700px">

      <div slot="title" style="height:20px;">
        <!-- 不要标题 -->
      </div>

      <MobileTicketTypePicker
        v-model = "valueData"
        ref = "mobileTicketTypePicker"
        @change = "onChange"
        @no_sub_item = "onSubmit"/>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onBeforeClose">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MobileTicketTypePicker from '@/components/mobile-ticket/MobileTicketTypePicker';
import EventBus from '@/assets/EventBus.js';

export default {
  name: "TicketTypeCascader",

  props: ['value', 'css'],

  mixins : [MobileTicketTypePicker],

  data() {
    return {
      valueData : null,
      iconClass : 'el-icon-arrow-down',
      ticketType : {},
      ticketTypeDefault : {},
      dialogVisible : false
    };
  },

  watch : {
    value(after, before) {
      console.log('#67 TicketTypeCascader watch', this.value, after, before);

      this.loadNameByValue(this.value);
    }
  },

  mounted() {
    // console.log('#73 TicketTypeCascader mounted', this.value);
    // this.loadNameByValue(this.value);

    var _this = this;
    EventBus.$on('load-ticket-type', id => {
      _this.loadNameByValue(id);
    });
  },

  methods : {
    onOpened() {
      // console.log('#79 onOpened', this);

      this.loadNameByValue(this.value);
    },

    loadNameByValue( _val ) {
      // console.log('#76 TicketTypeCascader.loadNameByValue', _val, this);

      var _this = this;
      if ( !_val ) {
        this.ticketTypeDefault = {};
        this.ticketType = {};
        return;
      }

      sdk.TicketTypeApi().findById({
        id : _val
      }).then(res => {
        if ( !!res ) {
          _this.ticketType = res;
        } else {
          _this.ticketType = { name : '类型 ' + _val };
        }

        if ( !_this.ticketTypeDefault || !_this.ticketTypeDefault.name ) {
          _this.ticketTypeDefault = res;
        }
      })
    },

    onMouseover() {
      this.iconClass = 'el-icon-close';
    },

    onMouseout() {
      this.iconClass = 'el-icon-arrow-down';
    },

    onBeforeClose() {
      if ( !!this.ticketTypeDefault && !!this.ticketTypeDefault.name ) {
        this.ticketType = this.ticketTypeDefault;
      }

      this.dialogVisible = false;
    },

    onChange( _val, _item) {
      this.ticketType = _item || {};
      this.valueData = _val;
    },

    onInputClick(e) {
      this.dialogVisible = true;

      var rect = e.target.getBoundingClientRect();

      // 右侧向
      if(rect.x > window.screen.width * 0.75) {
        var me_width = e.target.parentNode.getBoundingClientRect().width; // parentNode 为输入框

        $('.dialog_0 .el-dialog').css({
          "position" : "absolute",
          "left" : ( rect.x - 700 + me_width ) + "px", // 弹窗右侧对齐input的右侧
          "top" : rect.bottom + "px"
        });
        return;
      }

      // 默认向右
      $('.dialog_0 .el-dialog').css({
        "position" : "absolute",
        "left" : rect.x + "px", // 左侧对齐
        "top" : rect.bottom + "px"
      });
    },

    onDelIconClick() {
      console.log('#139 onDelIconClick', this);

      this.ticketType = {};
      this.$refs.mobileTicketTypePicker.reset();

      this.$emit('input', null);
      this.$emit('change', null);
    },

    onSubmit() {
      // console.log('#149 onSubmit', this.valueData, this);

      this.$emit('change', this.valueData);
      this.$emit('input', this.valueData);

      this.dialogVisible = false;
    }
  }
};
</script>

<style>
.input_0 input {
  cursor:pointer;
}

.el-dialog {
  z-index: 2020;
}

.dialog_0 .el-dialog__body {
  padding-bottom:30px!important;
  padding-left:5px!important;
}

.input_0 .el-input-group__append {
  background-color: unset;
  border-radius:0;
}

.input_0 .el-input__inner {
  border-right-width: 0;
}

.input_0 .icon_0 {
  position:relative;
  left:10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketTypeCascader.vue